import React from "react";
import "./genralcheckup.css"; // create a CSS file for styling
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function GeneralCheckupService() {
  return (
    <>
    <Helmet>
      <title>General Car Check-up Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Ensure your vehicle runs smoothly and safely with a General Car Check-up at AutoCare in Palwal. Expert car repair and maintenance services for optimal performance."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/general-checkup"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">
        {/* Left side text */}
        <div className="textContent">
          <h1>General Car Check-up Service</h1>

          <p>
            Ensure your vehicle runs smoothly and safely with a <strong>General Car Check-up</strong>. 
            At <strong>AutoCare</strong>, we provide expert <span className="highlight">car repair</span> 
            and maintenance services. Trusted <span className="highlight">Auto Care in Palwal</span> ensures your car is always in top condition.
          </p>

          <h2>What is a General Car Check-up?</h2>
          <p>
            A general car check-up is a comprehensive inspection of your vehicle’s key systems, including engine, brakes, battery, tires, and fluids. 
            Regular check-ups prevent unexpected breakdowns, improve performance, and extend the life of your car.
          </p>

          <h2>Our General Car Check-up Includes:</h2>
          <ul>
            <li>Engine performance and fluid check</li>
            <li>Brake system inspection</li>
            <li>Battery health and electrical system check</li>
            <li>Tyre inspection and rotation</li>
            <li>Lights, wipers, and safety equipment check</li>
            <li>Overall vehicle health report</li>
          </ul>

          <h2>Benefits of Choosing AutoCare</h2>
          <ul>
            <li>Expert technicians and reliable service</li>
            <li>Early detection of potential issues</li>
            <li>Enhances safety and driving comfort</li>
            <li>Trusted <span className="highlight">car repair service</span> in Palwal</li>
            <li>Improves long-term vehicle reliability</li>
          </ul>

          <h2>Book Your General Car Check-up</h2>
          <p>
            Looking for a trusted <span className="highlight">car repair</span>? 
            Schedule your <strong>General Car Check-up</strong> with <strong>AutoCare</strong> today and keep your vehicle running at its best.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book General Car Check-up
            </Link>
          </button>
        </div>

        {/* Right side image */}
        <div className="imageContent">
          <img src="/carServiceImages/genralcarcheckup.webp" alt="General Car Check-up Service" />
        </div>
      </div>
    </section>
    </>
  );
}
